import React, { useEffect, useRef, useState } from 'react'
import './UploadCompanyLogo.css';
import referenceLogo from '../assets/sapmle_company_light_logo.svg'
import LightCrosscon from '../assets/lightCrossIcon.svg'
import deleteImageIcon from '../assets/deleteIcon.svg'
import * as API from '../api.js';
import { Popup } from '../ReusableComponents/reusableFunctions.js';
import { useDispatch, useSelector } from 'react-redux';
import { updateProfileDetails } from '../redux/index.js';
import Button from '../ReusableComponents/Button/Button.js';
import TopBar from '../TopBar.js';


export default function UploadComapanyLogo({
  user
}) {
  const inputRef = useRef(null)
  const [userDetails, setUserDetails] = useState({})
  const [selectedImage, setSelectedImage] = useState(null);
  const [loading, setLoading] = useState(false)
  const [uploading, setUploading] = useState(false);
  const [editMode, seteditMode] = useState(false)
  const activeProfile = useSelector((state) => state.profile)
  const dispatch = useDispatch();

  const getLogoImageSrc = (theme) => {
    // If a new file has been picked, use its preview URL
    if (selectedImage?.imageUrl) {
      return selectedImage?.imageUrl;
    }

    // set here user existing logo image  
    const existingLogoUrl = userDetails?.company_logo;
    if (existingLogoUrl) return existingLogoUrl;

    return referenceLogo;
  };

  const getExistingLogoFileName = () => {
    // If user selected a new file, show its actual name
    if (selectedImage?.file?.name) {
      return selectedImage?.file?.name;
    }


    // set here user existing logo image
    const existingUrl = userDetails?.company_logo;
    if (existingUrl) {
      // Extract the extension from the URL, default to .png if not found
      const match = existingUrl.match(/\.(png|jpg|jpeg|svg)(?=[?&.]|$)/i);
      const ext = match ? match[1] : "png";
      return `MyCompanyLogo.${ext}`;
    }
    // If nothing exists, return nothing
    return undefined;
  };


  const getBase64 = file => {
    return new Promise(resolve => {
      let fileSize = file.size / 1000
      let baseURL = "";
      // Make new FileReader
      let reader = new FileReader();
      // Convert the file to base64 text
      reader.readAsDataURL(file);
      // on reader load somthing...
      reader.onload = () => {
        // Make a fileInfo Object
        baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };


  const handleFileChange = (event) => {
    const input = event.target;
    const file = input.files && input.files[0];


    if (!file) {
      // User canceled dialog: clear to allow next open to select same file
      input.value = '';
      return;
    }

    const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg', "image/svg+xml"];


    if (!allowedTypes.includes(file.type)) {
      Popup.alert("ERROR", "Only PNG,JPG or SVG files are allowed. Please select a valid image. ")
      input.value = ''; // clear invalid file from input
      return;
    }

    if (file.size > 1024 * 1024) {
      Popup.alert("ERROR", "Maximum allowed file size is 1MB. Please select a smaller image. ");
      input.value = '';
      return;
    }

    const imageUrl = URL.createObjectURL(file);
    getBase64(file)
      .then((base64Address) => {
        if (file.type === "image/svg+xml") {
          base64Address = base64Address.replace("image/svg+xml", "image/svg");
        }
        setSelectedImage({
          file,
          base64Address,
          imageUrl
        });
      })
      .catch((err) => {
        Popup.alert("ERROR", "something went wrong while converting image base64 ")
      })
      .finally(() => {
        input.value = '';
      });
  };

  const handleDeleteLogo = () => {
    setUploading(true);
    Popup.alert("WAIT", "deleting  logo ...")
    let filePath = userDetails?.cmp_logo;
    filePath = filePath?.split("companylogo/")[1];;
    filePath = "companylogo/" + filePath;
    API.deleteCompanyLogoAPI(filePath).then((res) => {
      if (res?.updatedUser) {
        dispatch(updateProfileDetails({
          user: { ...activeProfile?.user, company_logo: null, cmp_logo: null }
        }))
      }
      seteditMode(false)
      setSelectedImage(null);
      setUploading(false);
      inputRef.current.value = '';
      Popup.alert("COMPLETE", "Company logo deleted successfully ")
    }).catch((err) => {
      setUploading(false);
      Popup.alert("ERROR", err || err?.message || err?.errorMessage)
    })
  }


  const handleDeSelectFile = () => {
    setSelectedImage(prev => null);
  };

  const handleEdit = () => seteditMode(prev => !prev);

  const handleCancel = () => {
    seteditMode(false);
    setSelectedImage(prev => null);
  };

  const handleUploadCompanyLogo = async (e) => {
    setUploading(true);
    Popup.alert("WAIT", "Uploading logo ...")
    API.upload_Company_Logo(selectedImage?.base64Address).then((res) => {
      if (res?.updatedUser) {
        dispatch(updateProfileDetails({
          user: { ...activeProfile?.user, company_logo: res?.updatedUser?.company_logo }
        }))
        seteditMode(false);
        setSelectedImage(null);
        setUploading(false);
      }
      Popup.alert("COMPLETE", "company logo uploaded successfully ")
    }).catch((err) => {
      setUploading(false);
      Popup.alert("ERROR", e || e?.message || e?.errorMessage)
    })
  }


  const handleOpenFilePicker = () => {
    const el = inputRef.current;
    if (!el) return;

    el.value = '';  // Clear the input to allow selecting the same file again
    inputRef.current.click();     // Trigger the file dialog
  };


  useEffect(() => {
    if (activeProfile?.user) {
      setUserDetails(() => {
        return {
          ...user,
          cmp_logo: activeProfile?.user?.company_logo ? activeProfile?.user?.company_logo : null,
          company_logo: activeProfile?.user?.company_logo ? `${activeProfile?.user?.company_logo}?${activeProfile?.user?.sas_token}&t${new Date().getTime()}` : null
        }
      })
    }
  }, [activeProfile?.user])


  const existingLogoFileName = getExistingLogoFileName();
  const logoImageSrc = getLogoImageSrc();

  return (
    <div className='upload_logo_main_container'>

      {/* <div className="top-bar"><div className="top-bar-text">Upload Company Logo </div></div> */}
      <TopBar showLogo={false} title={"Upload Company Logo"} />
      <div className='upload_company_logo_wrapper'>
        <div className='upload_company_logo_header'>
          <h4>Company Logo</h4>
          <p>{activeProfile?.activeTeam}</p>
        </div>
        {loading ? <p>loading ...</p> : <div className={`upload_image_option`}>
          <div className="upload_image_option_wrapper">
            <h3 className="">Upload Company Logo</h3>
            {/* Update/Cancel buttons: shown iff edit mode is ON OR a new file is selected */}
            {(editMode || selectedImage) ? (
              <div className='buttons_wrapper'>
                <Button
                  isBtnActive
                  text={"Cancel"}
                  onClick={() => {
                    handleCancel()
                  }} />

                <Button isDisabled={(!!existingLogoFileName && !selectedImage)} isBtnActive text={"Update"} onClick={() => {
                  handleUploadCompanyLogo()
                }} />
              </div>
            ) : (
              <div style={{ display: "flex", width: "200px", gap: "1rem", justifyContent: "flex-end" }}>
                {!!existingLogoFileName &&
                  <Button isBtnActive text={"Edit"} onClick={() => {
                    handleEdit()
                  }} />}
              </div>

            )}
          </div>
          <div className='upload_image_file_select_wrapper'>
            <div className="reference_img_wrapper">
              <img
                width={110}
                src={logoImageSrc}
                alt={`company logo`}
              />
              {!existingLogoFileName && !selectedImage && (
                <p style={{ textAlign: "center", fontSize: "12px" }}>For Reference</p>
              )}
            </div>

            <div className={`upload_image_wrapper`}>
              <p className='description'>Upload your company logo here .The file must be PNG or JPG type. Logo size should be 1 MB or smaller and must be transparent</p>

              {/* ------------------------ FILE UI LOGIC -------------------------- */}
              {/* CASE 1: Existing logo, not in edit, no new file: only filename */}
              {!selectedImage && existingLogoFileName && !editMode && (
                <div className="file_name_wrapper">
                  <span>{existingLogoFileName}</span>
                </div>
              )}

              {/* CASE 2: Existing logo, edit mode ON, no new file */}
              {editMode && !selectedImage && existingLogoFileName && (
                <div style={{ width: "100%", display: "flex", gap: "1rem" }}>
                  <div className="file_name_wrapper ">
                    <span
                      style={{ cursor: 'pointer' }}
                      onClick={handleOpenFilePicker}
                    >
                      {existingLogoFileName}
                    </span>
                  </div>

                  <div >
                    <img
                      onClick={() => {
                        handleDeleteLogo()
                      }}
                      style={{ cursor: "pointer" }}
                      src={deleteImageIcon}
                      alt="Remove existing logo"
                    />
                  </div>
                </div>
              )}


              {/* CASE 3: New image selected (regardless of prior existence) */}
              {selectedImage && (
                <div className="file_name_wrapper">
                  <span onClick={handleOpenFilePicker} >{selectedImage.file?.name}</span>
                  <img
                    onClick={() => handleDeSelectFile()}
                    style={{ cursor: 'pointer' }}
                    src={LightCrosscon}
                    alt='Deselect image button'
                  />
                </div>
              )}

              <div className='file_upload_input'>
                <label className='cursor-pointer'>
                  <input
                    ref={inputRef}
                    type="file"
                    accept="image/*"
                    className='hidden'
                    onChange={e => handleFileChange(e)}
                  />
                </label>
              </div>

              {/* CASE 4: No file chosen, no existing logo, not in edit */}
              {!selectedImage && !existingLogoFileName && !editMode && (
                <button onClick={handleOpenFilePicker} className={`choose_file_button`}>
                  Choose file
                </button>
              )}
            </div>
          </div>
        </div>}

      </div>
    </div>
  )
}
